import { CBQChoice } from "../../../../api/Quiz/InitCBQQuestion";
import ChoicesEditor from "./ChoicesEditor";
import { QuestionTypeEditorProps } from "./types";

// multi_response: optionsJson { choices }, correctAnswerJson { answers:[], requiredCount }
const MultiResponseEditor = ({
  optionsJson,
  correctAnswerJson,
  onChange,
}: QuestionTypeEditorProps) => {
  const choices = (optionsJson.choices as CBQChoice[]) ?? [];
  const answers = (correctAnswerJson.answers as string[]) ?? [];
  // Defaults to 0; the admin sets it manually and it is never auto-changed
  // when choices/answers are edited.
  const requiredCount =
    (correctAnswerJson.requiredCount as number | undefined) ?? 0;

  const emit = (nextChoices: CBQChoice[], nextAnswers: string[]) =>
    onChange({
      optionsJson: { choices: nextChoices },
      correctAnswerJson: {
        answers: nextAnswers,
        requiredCount,
      },
    });

  const setChoices = (next: CBQChoice[]) => {
    const keys = next.map((c) => c.key);
    emit(
      next,
      answers.filter((a) => keys.includes(a))
    );
  };
  const toggle = (key: string) => {
    const next = answers.includes(key)
      ? answers.filter((a) => a !== key)
      : [...answers, key];
    emit(choices, next);
  };

  const setRequiredCount = (n: number) =>
    onChange({
      optionsJson: { choices },
      correctAnswerJson: { answers, requiredCount: n },
    });

  return (
    <div className="space-y-4">
      <ChoicesEditor
        choices={choices}
        onChange={setChoices}
        renderCorrectControl={(key) => (
          <input
            type="checkbox"
            checked={answers.includes(key)}
            onChange={() => toggle(key)}
            title="Mark correct"
            className="h-4 w-4 accent-[#4379EE]"
          />
        )}
      />
      <div>
        <label className="block font-medium text-burntBlack text-sm mb-1">
          Required count
        </label>
        <input
          type="number"
          step="any"
          min={0}
          value={requiredCount}
          onChange={(e) => setRequiredCount(Number(e.target.value))}
          className="h-10 w-32 px-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>
    </div>
  );
};

export default MultiResponseEditor;
